<template>
    <div>
        <div class="bg-white full-height d-flex align-items-center">
     <CRow class="p-2">
        <CCol sm="6">
            <img src="../assets/image/bg-SignUp.png" style="max-width:100%"/>
        </CCol>
        <CCol sm="6">
                <div class="custom-form-bg text-left d-flex justify-content-center">
                    <h3 class="font-color-101828 text-left custom-24px-600">Sign up now</h3>
                    <p class="font-color-98A2B3 text-left custom-16px-400">Begin Your Journey Today</p>
                    <CRow>
                        <CCol sm="6">

                            <label class="font-color-171717 text-left custom-16px-400">First Name</label>
                            <input type="text" class="custom-bg-btn-white-border"/>
                        </CCol>
                        <CCol sm="6">
                            <label class="font-color-171717 text-left custom-16px-400">Last Name</label>
                            <input type="text" class="custom-bg-btn-white-border"/>
                        </CCol>
                        <CCol sm="12">
                            <label class="font-color-171717 text-left custom-16px-400 mt-3">Email</label>
                    <input type="text" class="custom-bg-btn-white-border"/>
                    <label class="font-color-171717 text-left custom-16px-400 mt-3">Phone Number</label>
                    <input type="text" class="custom-bg-btn-white-border"/>
                    <input type="checkbox" /> <label class="custom-14px-400 font-color-98A2B3 text-center mt-3">Agree to <strong class="font-color-7F56D9">Terms & Conditions</strong></label>
                        </CCol>
                    </CRow>
                  
                    <CButton type="button" class="custom-default-btn bg-7F56D9 text-white mt-3 border-16px">Sign Up</CButton>
                    <CButton type="button" class="bg-white custom-bg-btn-white-border custom-default-btn mt-3"><img src="../assets/image/Google-Icon.png" width="24px" class="mr-2"/>Sign Up with Google</CButton>
                    <p class="custom-14px-400 font-color-98A2B3 text-center mt-3">Already have an account? <strong class="font-color-7F56D9" @click="GoToLogin()">Login</strong></p>
                </div>
        </CCol>
     </CRow>
    
    </div>
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: this.$route.query.email,
            phone: "",
            password: "",
            selectedUser: this.$route.query.type === 'individual' ? 'individual' : 'company',
            website: "",
            detail: "",
            has_number: false,
            has_lowercase: false,
            has_uppercase: false,
            has_special: false,

            userOptions: [{

                id: 1,
                UserType: "Candidate",


            }, ],
            isLanguagePopupVisible1: false,

            userEmail: "",
            userPassword: "",

            ErrorLogin: false,
            Message: "",

            response: "",
            lblGoogle: "Google",
            lblProgress: "Continue",
            MessageError: false




        };
    },
    created() {
        AOS.init();
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },


    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        password_check() {
            this.has_number = /\d/.test(this.password);
            this.has_lowercase = /[a-z]/.test(this.password);
            this.has_uppercase = /[A-Z]/.test(this.password);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);

            // Debugging logs
            console.log('Password:', this.password);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        registerAccount() {
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.Name === "" || this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.$route.query.type);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);

                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {
                                if (response.data.status !== 400) {

                                    if (
                                        this.$route.query.targetUrl != "" &&
                                        (this.$route.query.targetUrl != null) &
                                        (this.$route.query.targetUrl != undefined)
                                    ) {
                                        this.$router.push(this.$route.query.targetUrl);
                                    } else {
                                        this.isLanguagePopupVisible1 = true;
                                       // this.$router.push("Login");
                                    }
                                } else {
                                    this.Loading = false;
                                    this.Message = response.data.message;
                                    this.Error = true;
                                    this.MessageError = true;
                                }

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Profile");
        },
        async login() {
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    const type = this.$route.query.type;
                    const countryid = this.$route.query.countryid;
                    const phone = this.$route.query.phone;


                    this.getUserEmail(idToken, type, countryid, phone);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async getUserEmail(idToken, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    localStorage.setItem('idToken', idToken);
                    this.SetSession(idToken, this.user, type, countryid, phone);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async SetSession(idToken, email, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                if (response.status === 202) {
                    this.registerAccountGoogle(idToken, email, type, countryid, phone);

                } else if (response.status === 200) {
                    if (response.data.userType === 'company') {
                        this.$router.push("Dashboard");
                    } else {
                        this.$router.push("Profile");
                    }

                    console.error("Failed to fetch user information:", response);
                } else {
                    this.emailuser = response.message;
                    console.log("tets" + this.emailuser);
                    this.isLanguagePopupVisible1 = true;
                    this.registerAccountGoogle(this.emailuser, type, countryid, phone);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        registerAccountGoogle(idToken, email, type, countryid, phone) {

            const formData = new FormData();
            this.buttonLabel = 'Processing';
            formData.append("name", email);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("userType", type);
            formData.append("password", "");
            formData.append("website", this.website);
            formData.append("detail", this.detail);
            formData.append("countryId", countryid);


            this.$API
                .post(this.$Register, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.getUserEmailLogin(idToken)


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async getUserEmailLogin(idToken) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSessionLogin(idToken, this.user);

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async SetSessionLogin(idToken, email) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response); // Log the entire response object to see its structure
                if (response.status === 202) {
                    // Handle status 202
                } else if (response.status === 200) {
                    const userData = response.data; // Extract user data
                    console.log("User Data:", userData); // Log the user data object to see its structure

                    // Extract userType directly from userData
                    const userType = userData.userType;
                    console.log("User Type:", userType); // Log the user type

                    // Handle non-200 status code
                    if (response.data.data.userType === 'individual') {
                        this.$router.push("Profile");
                    } else if (response.data.data.userType === '-') {

                        this.$router.push("Profile");

                    } else {

                        this.$router.push("Dashboard");

                    }
                    console.error("Failed to fetch user information:", response);
                } else {
                    // Handle other status codes
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup()
        {
            this.isLanguagePopupVisible1 = false; 
            this.$router.push("Login");
        },
        GoToLogin()
        {
            this.$router.push("Login");
        }
    },



};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>